module.exports = __webpack_public_path__ + "img/igs.49131170.png";